export const isValidAgencyAccountId = (value: string): boolean => /^\d{12}$/.test(value);
